import { Portfolio, Tariff } from 'api';
import { IPortfolioParams, ITariffParams, ITariffPriceParams } from '../../hooks/usePortfolios';
import { generateUniqueKey } from '../Functions';

export const mapPortfolioFormToApi = (
	portfolioParams: IPortfolioParams,
	tariffList: ITariffParams[],
	tariffPriceList: ITariffPriceParams[]
) => {
	const tariffs: Tariff[] = tariffList.map((t) => ({
		id: t.id || 0,
		portfolioId: t.portfolioId || 0,
		name: t.name,
		level: t.level,
		group: t.group,
		tariffSegment: t.tariffSegment,
		productCategoryId: t.productCategoryId,
		offerTypePrices: tariffPriceList
			?.filter((p) => p.tariffKey === t.key)
			.map((tp) => ({
				price: Number(tp.price),
				cost: tp.cost ? Number(tp.cost) : 0,
				margin: tp.margin ? Number(tp.margin) : 0,
				offerTypeId: tp.offerTypeId!,
				maxDiscount: Number(tp.maxDiscount)
			}))
	}));

	let portfolio: Portfolio = {
		id: portfolioParams?.id,
		name: portfolioParams?.name,
		note: portfolioParams?.note ? portfolioParams?.note : null,
		active: portfolioParams?.active,
		offerPurpose: portfolioParams?.offerPurpose,
		tariffs: tariffs,
		productType: portfolioParams.productType,
		strictPrice: true // not used portfolioParams.strictPrice
	};
	return portfolio;
};

export const mapPortfolioApiToForm = (portfolio: Portfolio) => {
	let portfolioParams: IPortfolioParams = {};
	let tariffParamsList: any[] | undefined = [];
	let tariffPriceList: any[] | undefined = [];
	const portfolioNote = portfolio?.note ? portfolio?.note : '';
	const portfolioKey = generateUniqueKey();

	portfolioParams = {
		id: Number(portfolio?.id),
		key: portfolioKey,
		name: portfolio?.name || '',
		active: portfolio?.active,
		offerPurpose: portfolio?.offerPurpose || [],
		note: portfolioNote,
		strictPrice: true, // not used portfolio.strictPrice,
		productType: portfolio?.productType || []
	};
	tariffParamsList = portfolio?.tariffs?.map((t) => {
		const tariffKey = generateUniqueKey();
		const tariffPrices = t.offerTypePrices?.map((tp) => ({
			key: generateUniqueKey(),
			tariffKey: tariffKey,
			offerTypeId: tp.offerTypeId,
			cost: tp.cost,
			margin: tp.margin,
			price: tp.price,
			maxDiscount: tp.maxDiscount
		}));

		tariffPriceList?.push(tariffPrices);
		return {
			id: t.id,
			key: tariffKey,
			portfolioId: portfolio?.id,
			portfolioKey: portfolioKey,
			name: t.name,
			level: t.level,
			group: t.group,
			tariffSegment: t.productSegment,
			productCategoryId: t.productCategoryId,
			prices: tariffPrices?.flat()
		};
	});
	tariffPriceList = tariffPriceList.flat();
	return { portfolioParams, tariffParamsList, tariffPriceList };
};
